module.exports = __webpack_public_path__ + "backImg02.2478905e.png";